<template>
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11 1.08619L5.99999 5.96119L0.999991 1.08619C0.906325 0.992526 0.796991 0.945692 0.671991 0.945692C0.546991 0.945692 0.437658 0.992526 0.343991 1.08619C0.250325 1.17986 0.203491 1.28919 0.203491 1.41419C0.203491 1.53919 0.245158 1.64336 0.328491 1.72669L5.65649 6.91419C5.75016 7.00786 5.86482 7.05469 6.00049 7.05469C6.13616 7.05469 6.25082 7.00786 6.34449 6.91419L11.6725 1.74219C11.7558 1.64853 11.7975 1.53653 11.7975 1.40619C11.7975 1.27586 11.7507 1.16653 11.657 1.07819C11.5633 0.989859 11.454 0.945526 11.329 0.945192C11.204 0.944859 11.0947 0.991692 11.001 1.08569L11 1.08619Z"
            class="fill-current"
        />
    </svg>
</template>
